const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

export const getPhoneNumberValue = (phoneNumber = '') => {
  if (!phoneNumber) return '';

  return phoneNumber
    .split('')
    .filter((key: string) => allowedKeys.includes(key))
    .slice(0, 15)
    .join('');
};
